import styled, { css, keyframes } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { aiAgentColors } from "app/pages/sales-intelligence/modules/ai-agent/components";

const gradientMove = keyframes`
    0% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0% 50%;
    }
`;

export const StyledSuperAgentTextArea = styled.textarea<{ hasAction?: boolean; isLoading?: boolean }>`
    width: 100%;
    min-height: 109px;
    max-height: 268px;
    padding: 16px ${({ hasAction }) => (hasAction ? "56px" : "16px")} 16px 16px;
    field-sizing: content;

    border-radius: 24px;
    border: 1px solid ${colorsPalettes.carbon[100]};
    box-shadow: 0 3px 5px 0 #2a3e521f;

    box-sizing: border-box;

    resize: none;
    overflow-y: auto;

    ${setFontVariant("body1", colorsPalettes.carbon[500])}

    ${({ isLoading }) =>
        isLoading &&
        css`
            border: 2px solid transparent;
            background:
                linear-gradient(${colorsPalettes.carbon[0]}, ${colorsPalettes.carbon[0]}) padding-box,
                linear-gradient(
                        90deg,
                        ${aiAgentColors.gradient.blue},
                        ${aiAgentColors.gradient.lightBlue},
                        ${aiAgentColors.gradient.green},
                        ${aiAgentColors.gradient.lightBlue},
                        ${aiAgentColors.gradient.blue}
                    )
                    border-box;
            background-size:
                100% 100%,
                300% 100%;
            animation: ${gradientMove} 3s ease infinite;
        `}

    &::placeholder {
        color: ${colorsPalettes.carbon[300]};
    }

    &::-webkit-scrollbar {
        width: 7px;
    }
    &::-webkit-scrollbar-thumb {
        background: ${colorsPalettes.carbon[200]};
        border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: ${colorsPalettes.carbon[0]};
        margin: 12px 0;
    }

    &:disabled {
        background-color: ${colorsPalettes.carbon[25]};
    }
`;

export const StyledActionButtonWrapper = styled.div<{ $isDisabled?: boolean }>`
    position: absolute;
    right: 12px;
    bottom: 12px;
    ${({ $isDisabled }) =>
        $isDisabled &&
        css`
            pointer-events: none;
        `}
`;
